import React from 'react';
import { Button } from '../../../ui/button';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from './ThemeContext';

interface AdminTopBarProps {
    title: string;
    description: string;
    actionButton?: {
        label: string;
        icon?: React.ReactNode;
        onClick: () => void;
    };
}

export function AdminTopBar({ title, description, actionButton }: AdminTopBarProps) {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className="glass-strong border-b border-primary/30 px-8 py-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-foreground text-2xl font-bold mb-1">{title}</h1>
                    <p className="text-sm text-muted-foreground font-medium">{description}</p>
                </div>
                <div className="flex items-center gap-3">
                    <Button
                        onClick={toggleTheme}
                        variant="ghost"
                        size="icon"
                        className="text-primary hover:bg-primary/10 transition-all duration-300 hover:scale-110 hidden lg:flex"
                        title={
                            theme === 'dark' 
                                ? 'Dark Mode' 
                                : theme === 'light' 
                                    ? 'Light Mode' 
                                    : 'System Mode'
                        }
                    >
                        {theme === 'dark' ? (
                            <Moon className="w-5 h-5" />
                        ) : theme === 'light' ? (
                            <Sun className="w-5 h-5" />
                        ) : (
                            <Monitor className="w-5 h-5" />
                        )}
                    </Button>
                    {actionButton && (
                        <Button
                            onClick={actionButton.onClick}
                            className="bg-primary hover:bg-primary/90 transition-all duration-300 hover:scale-105 shadow-lg"
                        >
                            {actionButton.icon}
                            <span className="font-semibold">{actionButton.label}</span>
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}